import React, { memo } from 'react';
import { useRoutes } from 'react-router-dom';
import { ROUTES_MAP } from '../config';
import { useTitle } from '../hooks/useTitle';

export const SwitchRoutes = memo(() => {
  useTitle();
  return useRoutes([...ROUTES_MAP]);
});
